import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../utils/i18n';
import { getLogoSrc } from './Logo';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-[#0B1412]" data-id="element-781" data-mp="32o48q3wk3w3d">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-782" data-mp="36oxzr65apr0h">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-783" data-mp="36n3dnoiafsut">
          <div className="md:col-span-2" data-id="element-784" data-mp="3ud7h9vvh7slt">
            <Link to="/" className="inline-block mb-4" data-id="element-785" data-mp="38zaivynj750">
              {/* Footer uses the same wordmark as the navbar, recolored to brand
                  green. The artwork is used as a CSS mask so the green fills its
                  exact shape — an <img> can't be tinted, only inverted. */}
              <span role="img" aria-label="206Gravel" className="block h-10 w-40" style={{
              backgroundColor: '#04A05C',
              WebkitMaskImage: `url(${getLogoSrc(undefined, 'light')})`,
              maskImage: `url(${getLogoSrc(undefined, 'light')})`,
              WebkitMaskRepeat: 'no-repeat',
              maskRepeat: 'no-repeat',
              WebkitMaskPosition: 'left center',
              maskPosition: 'left center',
              WebkitMaskSize: 'contain',
              maskSize: 'contain',
              width: "382px",
              height: "48px"
            }} data-id="element-786" data-mp="29yxcjbkkrila" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-787" data-mp="3v5n8okwjdq1a">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-788" data-mp="81yxwl8ju251">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-789" data-mp="81fqhygiyw59">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-790" data-mp="32339clqrn25">
              <li data-id="element-791" data-mp="hsaeb79f63st">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-792" data-mp="huwg0q9mpp34">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-793" data-mp="qub7nt1j85p7">
                <a href="mailto:info@206gravel.com" className="hover:text-white/70 transition-colors" data-id="element-794" data-mp="qtrne5oet580">
                  info@206gravel.com
                </a>
              </li>
              <li data-id="element-795" data-mp="twfo3t7e3vrw">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-796" data-mp="ytoay73hgnzh">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-797" data-mp="yv953vlvy4wt">
              Products
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-798" data-mp="13sir11a2fyfw">
              <li data-id="element-799" data-mp="18k959ic4j6cl"><Link to="/?category=Base%20%26%20Compaction#materials" className="hover:text-white/70 transition-colors" data-id="element-800" data-mp="18k93pdwh6yah">Base &amp; Compaction</Link></li>
              <li data-id="element-801" data-mp="1cnp32hzxjcqv"><Link to="/?category=Clear%20%26%20Drain#materials" className="hover:text-white/70 transition-colors" data-id="element-802" data-mp="1cnypxwpoh3sc">Clear &amp; Drain</Link></li>
              <li data-id="element-803" data-mp="1mjihk6x7lgba"><Link to="/?category=Soil%2C%20Mulch%20%26%20Org.#materials" className="hover:text-white/70 transition-colors" data-id="element-804" data-mp="1mkto2ei1h263">Soil, Mulch &amp; Org.</Link></li>
              <li data-id="element-805" data-mp="3ob54nxdzcr2h"><Link to="/?category=Quarry%20Rock#materials" className="hover:text-white/70 transition-colors" data-id="element-806" data-mp="3ob5681tmoz4l">Quarry Rock</Link></li>
              <li data-id="element-807" data-mp="3tb9ljoisvnt8"><Link to="/?category=Landscape%20%26%20Decor#materials" className="hover:text-white/70 transition-colors" data-id="element-808" data-mp="3tb9jzk35jfr4">Landscape &amp; Decor</Link></li>
            </ul>
          </div>

          <div data-id="element-809" data-mp="25o58ygmttnbm">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-810" data-mp="25nc8fxegnu1x">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-811" data-mp="21n1thv8oxtax">
              <li data-id="element-812" data-mp="1wp0afab9ltzg">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-813" data-mp="1wpjt4t8qomej">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-814" data-mp="2pdflxmv6tu61">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-815" data-mp="2pd5x42lvpt1x">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-816" data-mp="2fdf1fxll1809">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-817" data-mp="2fdyk5gj240fc">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-818" data-mp="13y9x6p5sz1ej">
                <Link to="/blog" className="hover:text-white/70 transition-colors" data-id="element-819" data-mp="13xqdp40i84ye">
                  {t('footer.blog')}
                </Link>
              </li>
              <li data-id="element-820" data-mp="2wmpouhw0jsk6">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-821" data-mp="2wn98c31bap0b">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
              <li data-id="element-822" data-mp="2ntmhmrbyobxz">
                <Link to="/service-areas" className="hover:text-white/70 transition-colors" data-id="element-823" data-mp="2nv7amcimnmtq">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-824" data-mp="3fk0m5wy34bwz">
          <p data-id="element-825" data-mp="31lau4vq4h2fh">
            &copy; {new Date().getFullYear()} 206Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-826" data-mp="36mqe0kgkd2wa">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-827" data-mp="1q647bc2nj1rv">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors" data-id="element-828" data-mp="1v6rvzr3er6ix">
              {t('footer.terms')}
            </Link>
            <Link to="/refund-policy" className="hover:text-white transition-colors" data-id="element-829" data-mp="1ine5q6q30b34">
              {t('footer.refund')}
            </Link>
          </div>
        </div>
      </div>

      {/* Our Network — thin horizontal strip pinned to the very bottom of
                                          the site. Forest-green background, black text. */}
      <div className="w-full bg-[#000000]" data-id="element-830" data-mp="13y8a0sqgd2zz">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-row flex-nowrap items-center justify-center gap-x-3 sm:gap-x-5 text-[11px] sm:text-sm font-bold text-black whitespace-nowrap overflow-x-auto scrollbar-hide bg-[#000000]" data-id="element-831" data-mp="zwn1tkov5cw4">
          <span className="uppercase tracking-[0.1em] sm:tracking-[0.14em] shrink-0 font-[700] text-[#57534e]" data-id="element-832" data-mp="18vqlaprxzub5">
            Our Network
          </span>
          <a href="https://253gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-833" data-mp="g8xim1uzskyi">
            253gravel.com
          </a>
          <a href="https://206gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-834" data-mp="2l9qddmksbt88">
            206gravel.com
          </a>
          <a href="https://425gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-835" data-mp="2q2jhq9ccczjs">
            425gravel.com
          </a>
        </div>
      </div>
    </footer>;
}